import React, { Component } from 'react'

export class ParcelBookings extends Component {
  render() {
    return (
      <div>ParcelBookings</div>
    )
  }
}

export default ParcelBookings